import React, { createContext, useState } from 'react';
import { styled } from '@material-ui/core/styles';

import Controls from './components/Controls/Controls';
import MenuBar from './components/MenuBar/MenuBar';
import ReconnectingNotification from './components/ReconnectingNotification/ReconnectingNotification';
import Room from './components/Room/Room';

import useRoomState from './hooks/useRoomState/useRoomState';
import useMeetingState from './hooks/useMeetingState/useMeetingState';
import useHeight from './hooks/useHeight/useHeight';
import { IMeetingContext } from './hooks/useMeetingState/useMeetingState';
import MeetingEnd from './components/MeetingEnd/MeetingEnd';
import useVideoContext from './hooks/useVideoContext/useVideoContext';
import AlertDialog from './components/MenuBar/AlertDialog/AlertDialog';
import NetworkError from './components/NetworkError/NetworkError';
import LandingPage from './components/LandingPage/LandingPage';

const Container = styled('div')({
  display: 'grid',
  gridTemplateRows: 'auto 1fr',
});

const Main = styled('main')({
  overflow: 'hidden',
});

export const MeetingContext = createContext<IMeetingContext>(null!);
export const ToolBarContext = createContext(null!);

export default function App() {
  const height = useHeight();
  const roomState = useRoomState();
  const { meeting, company, job, customer, roomName, userType, validLink, isMobile } = useMeetingState();
  const { meetingEndedByHost, networkError } = useVideoContext();
  const [toolbarEnabled, setToolbarEnabled] = useState(false);
  const [snackBar, setSnackBar] = useState(false);
  const [snackBarText, setSnackBarText] = useState('');
  const [sketchTouched, setSketchTouched] = useState(false);
  const [meetingEnded, setMeetingEnded] = useState(false);

  return (
    <Container style={{ height }}>
      <MeetingContext.Provider value={{ meeting, company, job, customer, userType, roomName, validLink, isMobile }}>
        <ToolBarContext.Provider
          value={{
            toolbarEnabled,
            setToolbarEnabled,
            snackBar,
            setSnackBar,
            snackBarText,
            setSnackBarText,
            sketchTouched,
            setSketchTouched,
            setMeetingEnded,
            meetingEnded,
          }}
        >
          <MenuBar />
          <NetworkError />
          {networkError ? null : !meetingEnded ? (
            <>
              <Main>
                {roomState === 'disconnected' ? <LandingPage /> : <Room />}
                <Controls />
              </Main>
            </>
          ) : (
            <MeetingEnd meetingEndedByHost={meetingEndedByHost} />
          )}
          {meetingEndedByHost && <AlertDialog alertType="meetingEnded" />}
          {meeting && meeting.meeting_status !== 'OPEN' && <AlertDialog alertType={`meetingExpired${userType}`} />}
        </ToolBarContext.Provider>
        <ReconnectingNotification />
      </MeetingContext.Provider>
    </Container>
  );
}
